import type { CiiShipTypeRuleDto } from './_requests'

// These formulas preserve the existing Ship Data final-rating behavior.
export const calculateAnnualAttainedCii = (totalCo2: number, capacity: number, correctedDistance: number, correctionFactorProduct: number) => {
  const denominator = correctionFactorProduct * capacity * correctedDistance
  return denominator > 0 ? (totalCo2 * 1000000) / denominator : 0
}

export const getFinalCalculatedCiiRating = (attainedCii: number, requiredCii: number, rule?: CiiShipTypeRuleDto | null) => {
  if (requiredCii <= 0 || attainedCii < 0) return '--'
  const d1 = Number(rule?.ratingD1) || 0.82
  const d2 = Number(rule?.ratingD2) || 0.93
  const d3 = Number(rule?.ratingD3) || 1.08
  const d4 = Number(rule?.ratingD4) || 1.28
  const ratio = attainedCii / requiredCii
  if (ratio < d1) return 'A'
  if (ratio < d2) return 'B'
  if (ratio < d3) return 'C'
  if (ratio < d4) return 'D'
  return 'E'
}
